import { combineReducers } from 'redux';

import { authReducers } from 'auth/reducers';
import { custom_fields_employeesReducers } from '../modules/secured/modules/custom_fields_employees/reducers';
import { employeesReducers } from 'employees/reducers';
import { notification_configReducers } from 'notifications_config/reducers';
import { notification_historicReducers } from 'notifications_historic/reducers';
import { messagesReducers } from 'messages/reducers';
import { companiesReducers } from 'companies/reducers';
import { subcompaniesReducers } from 'subcompanies/reducers';
import { usersReducers } from 'users/reducers';
import { securedReducers } from 'secured/reducers';
import { rolesReducers } from 'roles/reducers';
import { importReducers } from 'import/reducers';
import { accountsReducers } from 'accounts/reducers';
import { subaccountsReducers } from 'subaccounts/reducers';
import { depreciationsReducers } from 'depreciations/reducers';
import { inpcReducers } from 'inpc/reducers';
import { costCentersReducers } from 'cost_centers/reducers';
import { exchangeReducers } from 'exchange/reducers';
import listsNew from 'containers/lists/reducers-new';
import { catalogsReducers } from 'catalogs/reducers';
import { locationsReducers } from 'locations/reducers';
import { groupsReducers } from 'groups/reducers';
import { projectsReducers } from 'projects/reducers';
import { asset_levelReducers } from 'asset_level/reducers';
import { providersReducers } from 'providers/reducers';

import dashboard from 'containers/dashboard/reducers';
import assets from 'containers/assets/reducers';
import reports from 'reports/reducers';

const RootReducer = combineReducers({
  accounts: accountsReducers,
  assets,
  asset_level: asset_levelReducers,
  auth: authReducers,
  catalogs: catalogsReducers,
  companies: companiesReducers,
  costCenters: costCentersReducers,
  custom_fields_employees: custom_fields_employeesReducers,
  groups: groupsReducers,
  dashboard,
  depreciations: depreciationsReducers,
  employees: employeesReducers,
  exchange: exchangeReducers,
  import: importReducers,
  inpc: inpcReducers,
  listsNew,
  locations: locationsReducers,
  message: messagesReducers,
  notifications_config: notification_configReducers,
  notifications_historic: notification_historicReducers,
  projects: projectsReducers,
  providers: providersReducers,
  reports,
  roles: rolesReducers,
  secured: securedReducers,
  subaccounts: subaccountsReducers,
  subcompanies: subcompaniesReducers,
  users: usersReducers,
});

export default RootReducer;



// WEBPACK FOOTER //
// src/store/reducers.js